// :cow: Cosmose CONFIDENTIAL :iso:
import { Injectable } from '@angular/core';

@Injectable()
export class StepPositionService {

  private readonly spacing = 12;

  getLeftPosition(containerRect: ClientRect, dialogRect: ClientRect, portalRect: ClientRect): number {
    let left;
    if (portalRect.width > dialogRect.width) {
      // center
      left = portalRect.left + ((portalRect.width - dialogRect.width) / 2);
    } else {
      // move away from right border
      if (containerRect.width - portalRect.left < dialogRect.width) {
        left = containerRect.width - dialogRect.width - this.spacing;
      } else {
        left = portalRect.left;
      }

      //6px = internal border padding
      left = left - 6;
    }

    return left;
  }

  getTopPosition(containerRect: ClientRect, dialogRect: ClientRect, portalRect: ClientRect): number {
    const topOffset = portalRect.top - containerRect.top;
    if (topOffset >= dialogRect.height + this.spacing) {
      return portalRect.top - dialogRect.height - this.spacing + document.body.parentElement.scrollTop;
    } else {
      return portalRect.top + portalRect.height + this.spacing + document.body.parentElement.scrollTop;
    }
  }
}
